var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { addSeconds, differenceInCalendarDays } from "date-fns";
import { createPPNHotelAPIQueryString, formatPPNPostalCode, fetcher, TravelError, } from "@travel/shared/utils";
import { TravelAPI } from "@travel/shared/data-access";
import { transformHotel, mutateHotelContract, transformHotelReview, flattenHotelRooms, } from "@travel/hotel/shared/utils";
export var getHotel = TravelAPI({
    name: "hotel",
    url: function (request) {
        return "/hotel/details?".concat(createPPNHotelAPIQueryString({
            location: {
                id: request.id,
                type: "hotel",
            },
        }, { singleHotel: true }), "&photos=true&important_info=true&recent=true&guest_score_breakdown=true&reviews=true");
    },
    mutate: function (data) {
        var _a;
        var list = (_a = (Array.isArray(data) ? data : data.searchResults)) === null || _a === void 0 ? void 0 : _a.map(transformHotel);
        var hotel = list[0];
        if (!hotel) {
            throw new TravelError({
                message: "",
            });
        }
        return {
            hotel: hotel,
        };
    },
});
export var getHotelAvailability = TravelAPI({
    name: "hotel:availability",
    url: function (request) {
        return "/hotel/availability?".concat(createPPNHotelAPIQueryString(request));
    },
});
export var getHotelAvailabilityURL = TravelAPI({
    url: function (request) {
        return "/hotel/availability?".concat(createPPNHotelAPIQueryString(request));
    },
    json: false,
});
export function getHotelRatesWithDeals(_a) {
    var _b;
    var includeMemberDeals = _a.includeMemberDeals, includeCUGDeals = _a.includeCUGDeals, request = __rest(_a, ["includeMemberDeals", "includeCUGDeals"]);
    return __awaiter(this, void 0, void 0, function () {
        var _c, rates, memberRates, clubRates, roomsWithDeals, _d, _e, memberRoom, _f, _g, isDeal;
        var e_1, _h, e_2, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        !includeCUGDeals && !includeMemberDeals
                            ? getHotelRates(__assign(__assign({}, request), { includeMemberDeals: false, includeCUGDeals: false }))
                            : Promise.resolve(undefined),
                        !includeCUGDeals
                            ? getHotelRates(__assign(__assign({}, request), { includeMemberDeals: true, includeCUGDeals: false }))
                            : Promise.resolve(undefined),
                        includeCUGDeals
                            ? getHotelRates(__assign(__assign({}, request), { includeMemberDeals: true, includeCUGDeals: true }))
                            : Promise.resolve(undefined),
                    ])];
                case 1:
                    _c = __read.apply(void 0, [_k.sent(), 3]), rates = _c[0], memberRates = _c[1], clubRates = _c[2];
                    if (includeCUGDeals && clubRates)
                        return [2 /*return*/, clubRates];
                    else if (includeMemberDeals && memberRates)
                        return [2 /*return*/, memberRates];
                    else if (!rates)
                        throw new Error("No Rates Found");
                    roomsWithDeals = {};
                    if ((_b = memberRates === null || memberRates === void 0 ? void 0 : memberRates.list) === null || _b === void 0 ? void 0 : _b.length) {
                        try {
                            for (_d = __values(memberRates.list), _e = _d.next(); !_e.done; _e = _d.next()) {
                                memberRoom = _e.value;
                                try {
                                    for (_f = (e_2 = void 0, __values(memberRoom.rates)), _g = _f.next(); !_g.done; _g = _f.next()) {
                                        isDeal = _g.value.isDeal;
                                        if (isDeal) {
                                            roomsWithDeals[memberRoom.id] = memberRoom;
                                            break;
                                        }
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_g && !_g.done && (_j = _f.return)) _j.call(_f);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_h = _d.return)) _h.call(_d);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    return [2 /*return*/, rates];
            }
        });
    });
}
export var getHotelRates = TravelAPI({
    name: "hotel:rates",
    url: function (_a) {
        var id = _a.id, includeMemberDeals = _a.includeMemberDeals, includeCUGDeals = _a.includeCUGDeals, rest = __rest(_a, ["id", "includeMemberDeals", "includeCUGDeals"]);
        var url = "/hotel/multiContract?".concat(createPPNHotelAPIQueryString(__assign(__assign({}, rest), { location: {
                id: id,
                type: "hotel",
            } }), { singleHotel: true }), "&room_bedding=1&room_amenities=1&room_photos=1&output_version=4");
        url += "&showCUG=".concat(String(!!includeCUGDeals));
        url += "&showMemberDeal=".concat(String(!!includeMemberDeals));
        return url;
    },
    //cache: "no-store",
    next: {
        revalidate: 30,
    },
    mutate: function (data, request) {
        var _a, _b;
        var meta = {
            nightsCount: differenceInCalendarDays(request.checkOut, request.checkIn),
            roomCount: request.roomCount,
        };
        var _c = __read((_b = (Array.isArray(data)
            ? data
            : data.searchResults || ((_a = data === null || data === void 0 ? void 0 : data.results) === null || _a === void 0 ? void 0 : _a.hotel_data))) === null || _b === void 0 ? void 0 : _b.map(function (hotel) { return transformHotel(hotel, meta); }), 1), hotel = _c[0];
        var list = flattenHotelRooms(hotel.rooms);
        var filters = computeAvailableHotelRateFilters(list);
        //@TODO: Refactor API so this is at the Room Level
        if (hotel.hasBetterDeal && list[0]) {
            list[0].hasBetterDeal = true;
        }
        if (!list.length) {
            throw new TravelError({
                message: "NO_RATES_FOUND",
                request: request,
            });
        }
        return {
            list: list,
            totalListCount: list.length,
            filter: {
                applied: {},
                available: filters,
                all: filters,
            },
        };
    },
});
export var getHotelContract = TravelAPI({
    name: "hotel:contract",
    url: function (_a) {
        var id = _a.id, currency = _a.currency, isVIP = _a.isVIP, isMember = _a.isMember;
        return "/hotel/contract?ppn_bundle_id=".concat(id, "&room_bedding=1&room_amenities=1&currency=").concat((currency || "usd").toUpperCase(), "&showCUG=").concat(!!isVIP, "&showMemberDeal=").concat(!!isMember);
    },
    cache: "no-store",
    mutate: function (data, _a) {
        var id = _a.id;
        var contract = __assign(__assign({}, mutateHotelContract(data)), { id: id });
        return { contract: contract };
    },
});
export function findBestHotelContract(_a) {
    var roomID = _a.roomID, roomName = _a.roomName, request = __rest(_a, ["roomID", "roomName"]);
    return __awaiter(this, void 0, void 0, function () {
        var loadRates, _b, rates, memberRates, clubRates, findBest, cheapest, bestMemberDeal, bestClubDeal;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    loadRates = function (promise) { return __awaiter(_this, void 0, void 0, function () {
                        var result, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, promise];
                                case 1:
                                    result = _b.sent();
                                    return [2 /*return*/, result];
                                case 2:
                                    _a = _b.sent();
                                    return [2 /*return*/, { list: [] }];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    return [4 /*yield*/, Promise.all([
                            loadRates(getHotelRates(__assign(__assign({}, request), { includeMemberDeals: false, includeCUGDeals: false }))),
                            !request.includeCUGDeals
                                ? loadRates(getHotelRates(__assign(__assign({}, request), { includeMemberDeals: true, includeCUGDeals: false })))
                                : Promise.resolve(undefined),
                            request.includeCUGDeals
                                ? loadRates(getHotelRates(__assign(__assign({}, request), { includeMemberDeals: true, includeCUGDeals: true })))
                                : Promise.resolve(undefined),
                        ])];
                case 1:
                    _b = __read.apply(void 0, [_c.sent(), 3]), rates = _b[0], memberRates = _b[1], clubRates = _b[2];
                    findBest = function (_a) {
                        var _b;
                        var list = _a.list;
                        return (_b = list.find(function (room) { return room.id === roomID || room.name === roomName; })) === null || _b === void 0 ? void 0 : _b.rates[0];
                    };
                    cheapest = findBest(rates);
                    bestMemberDeal = (memberRates === null || memberRates === void 0 ? void 0 : memberRates.list) ? findBest(memberRates) : undefined;
                    bestClubDeal = (clubRates === null || clubRates === void 0 ? void 0 : clubRates.list) ? findBest(clubRates) : undefined;
                    return [2 /*return*/, {
                            bestDeal: bestClubDeal || bestMemberDeal || cheapest,
                        }];
            }
        });
    });
}
export var MAX_BOOKING_TIMEOUT = 200;
export var startBookHotelContract = TravelAPI({
    name: "hotel:contract:book:start",
    method: "POST",
    url: function (_a) {
        var isVIP = _a.isVIP, isMember = _a.isMember;
        return "/hotel/book?showCUG=".concat(!!isVIP, "&showMemberDeal=").concat(!!isMember);
    },
    mutateRequest: createHotelContractAPIRequest,
    mutate: function (data) {
        var statusID = (data === null || data === void 0 ? void 0 : data.sessionId) || "";
        if (!statusID) {
            new TravelError({
                message: "Booking error. Please try again.",
            });
        }
        return {
            statusID: statusID,
            started: new Date().toJSON(),
            ends: addSeconds(new Date(), MAX_BOOKING_TIMEOUT).toJSON(),
        };
    },
});
export var getBookHotelContractStatus = TravelAPI({
    name: "hotel:contract:book",
    method: "POST",
    url: function () { return "/hotel/book"; },
    mutate: mutateHotelContract,
}, function (url, init, request, options) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(request === null || request === void 0 ? void 0 : request.statusID)) {
                        throw new TravelError({
                            message: "Booking error. Please try again.",
                        });
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getBookingStatus(url, request.statusID)];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, resolve(result)];
                case 3:
                    error_1 = _a.sent();
                    reject(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
});
export var bookHotelContract = TravelAPI({
    name: "hotel:contract:book",
    method: "POST",
    url: function (_a) {
        var isVIP = _a.isVIP, isMember = _a.isMember;
        return "/hotel/book?showCUG=".concat(!!isVIP, "&showMemberDeal=").concat(!!isMember);
    },
    mutateRequest: createHotelContractAPIRequest,
    mutate: mutateHotelContract,
}, function (url, init, request, options) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var bookData, result, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetcher(url, init, request, options)];
                case 1:
                    bookData = (_a.sent()).data;
                    if (!(bookData === null || bookData === void 0 ? void 0 : bookData.sessionId)) {
                        return [2 /*return*/, reject(new TravelError({
                                message: "Booking error. Please try again.",
                            }))];
                    }
                    return [4 /*yield*/, getBookingStatus(url, bookData.sessionId)];
                case 2:
                    result = _a.sent();
                    resolve(result);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    reject(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
});
function getBookingStatus(url, sessionID, options) {
    var _this = this;
    return new Promise(function (resolve, reject) {
        var started = Date.now();
        var getBookingStatus = function () { return __awaiter(_this, void 0, void 0, function () {
            var statusError, statusResult, error_3;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetcher("".concat(url.split("?")[0], "/session/").concat(sessionID), {
                                method: "GET",
                                cache: "no-store",
                            }, undefined, __assign(__assign({}, options), { allowErrors: true }))];
                    case 1:
                        statusResult = _e.sent();
                        switch ((_a = statusResult === null || statusResult === void 0 ? void 0 : statusResult.data) === null || _a === void 0 ? void 0 : _a.status) {
                            case "complete":
                                return [2 /*return*/, resolve(statusResult)]; //@TODO: Fix typing!!
                            case "failed":
                                return [2 /*return*/, reject(new TravelError({
                                        url: url,
                                        message: ((_c = (_b = statusResult === null || statusResult === void 0 ? void 0 : statusResult.data) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.status) ||
                                            ((_d = statusResult === null || statusResult === void 0 ? void 0 : statusResult.data) === null || _d === void 0 ? void 0 : _d.error) ||
                                            (statusResult === null || statusResult === void 0 ? void 0 : statusResult.data) ||
                                            statusResult,
                                        source: options === null || options === void 0 ? void 0 : options.sourceCode,
                                        partnerID: options === null || options === void 0 ? void 0 : options.partnerID,
                                    }))];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _e.sent();
                        if (Number(error_3 === null || error_3 === void 0 ? void 0 : error_3.code) === 404) {
                            return [2 /*return*/, reject(error_3)];
                        }
                        statusError = error_3;
                        return [3 /*break*/, 3];
                    case 3:
                        // If we've been polling for >= 180 seconds, kill it
                        if ((Date.now() - started) / 1000 >= MAX_BOOKING_TIMEOUT) {
                            reject(new TravelError({
                                url: url,
                                message: "Booking timeout. Please try again",
                                source: options === null || options === void 0 ? void 0 : options.sourceCode,
                                partnerID: options === null || options === void 0 ? void 0 : options.partnerID,
                            }));
                        }
                        else {
                            // Keep trying
                            setTimeout(getBookingStatus, 2000);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        getBookingStatus();
    });
}
export var cancelHotelContract = TravelAPI({
    name: "hotel:contract:cancel",
    method: "POST",
    url: function () { return "/hotel/bookings/cancel"; },
    mutateRequest: function (_a) {
        var _b;
        var bookingID = _a.bookingID, cancellation = _a.cancellation, payment = _a.payment;
        return ({
            ppn_bundle: cancellation === null || cancellation === void 0 ? void 0 : cancellation.id,
            booking_id: bookingID,
            email: (_b = payment === null || payment === void 0 ? void 0 : payment.billing) === null || _b === void 0 ? void 0 : _b.email,
        });
    },
});
export var getHotelBooking = TravelAPI({
    name: "hotel:booking:get",
    method: "POST",
    url: function () { return "/hotel/bookings/details"; },
    cache: "no-store",
    mutateRequest: function (_a) {
        var email = _a.email, bookingID = _a.bookingID, currency = _a.currency;
        return ({
            email: email,
            currency: currency === null || currency === void 0 ? void 0 : currency.toUpperCase(),
            booking_id: bookingID,
        });
    },
    mutate: mutateHotelContract,
});
export var getHotelReviews = TravelAPI({
    name: "hotel:reviews",
    url: function (_a) {
        var id = _a.id, _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 5 : _c;
        return "/hotel/reviews?hotel_id=".concat(id, "&offset=").concat(from, "&limit=").concat(to - from);
    },
    mutate: function (data) {
        var _a;
        var list = ((_a = data.review_data) === null || _a === void 0 ? void 0 : _a.map(transformHotelReview)) || [];
        return {
            list: list,
            totalListCount: data.review_count,
        };
    },
});
export function computeAvailableHotelRateFilters(list) {
    return {};
}
function createHotelContractAPIRequest(input) {
    var _a;
    var id = input.id, billing = input.billing, card = input.card, guests = input.guests, initials = input.initials, partnerID = input.partnerID, campaign = input.campaign, ad = input.ad, cid = input.cid, fraud = input.fraud, hotelID = input.hotelID;
    var _b = __read((card === null || card === void 0 ? void 0 : card.expires).split("/"), 2), cardExpiresMonth = _b[0], cardExpiresYear = _b[1];
    var ppnBookingRequest = {
        ppn_bundle_id: id,
        name_first: guests[0].firstName,
        name_last: guests[0].lastName,
        country_code: billing === null || billing === void 0 ? void 0 : billing.countryCode,
        address_line_one: billing === null || billing === void 0 ? void 0 : billing.line1,
        address_city: billing === null || billing === void 0 ? void 0 : billing.city,
        address_postal_code: formatPPNPostalCode(billing === null || billing === void 0 ? void 0 : billing.countryCode, billing === null || billing === void 0 ? void 0 : billing.postalCode),
        phone_number: (_a = billing === null || billing === void 0 ? void 0 : billing.phone) === null || _a === void 0 ? void 0 : _a.number,
        email: billing === null || billing === void 0 ? void 0 : billing.email,
        //card_number: card.number,
        card_holder: card === null || card === void 0 ? void 0 : card.name,
        card_number: card === null || card === void 0 ? void 0 : card.alias,
        card_type: card === null || card === void 0 ? void 0 : card.type,
        expires: "".concat(cardExpiresMonth).concat(cardExpiresYear.length === 2 ? "20".concat(cardExpiresYear) : cardExpiresYear),
        refclickid: "".concat(partnerID).concat(campaign ? ":".concat(campaign) : "").concat(ad ? ":".concat(ad) : ""),
        campaign: campaign,
        ad: ad,
        cid: cid,
        fraud: fraud,
        /*hotel_url: `${
              isClient ? location.origin : ""
            }/hotels/property/${hotelID}`,
            review_url: `${isClient ? location.origin : ""}/trips/find`,*/
    };
    if (typeof initials === "string") {
        ppnBookingRequest.initials = initials.toUpperCase();
    }
    if (guests.length > 1) {
        var _c = guests
            .slice(1, guests.length)
            .reduce(function (acc, _a, index) {
            var firstName = _a.firstName, lastName = _a.lastName;
            acc.guestFirstNames.push(firstName);
            acc.guestLastNames.push(lastName);
            return acc;
        }, { guestFirstNames: [], guestLastNames: [] }), guestFirstNames = _c.guestFirstNames, guestLastNames = _c.guestLastNames;
        ppnBookingRequest.guest_name_first = guestFirstNames;
        ppnBookingRequest.guest_name_last = guestLastNames;
    }
    if (billing === null || billing === void 0 ? void 0 : billing.line2) {
        ppnBookingRequest.address_line_two = billing.line2;
    }
    if (billing === null || billing === void 0 ? void 0 : billing.stateCode) {
        ppnBookingRequest.address_state_code = billing.stateCode;
    }
    if (card === null || card === void 0 ? void 0 : card.cvvAlias) {
        ppnBookingRequest.cvv = card.cvvAlias;
    }
    return ppnBookingRequest;
}
